module.exports = __webpack_public_path__ + "static/media/captcha-img.557c51fa.jpg";